import { Dispatch, FC, SetStateAction } from 'react';
import { ProductType } from '@/remoteApi/ProductTypeApi';
import { Box, Flex, Title } from '@mantine/core';
import { FormTemplate } from '@/remoteApi/types/form-template.types';
import { FormAnswerMap, FormDetails, FormOptions, QuantityPerDimensionForm } from './ProductTypeForm';
import { OrderDetails } from './OrderDetails';
import { QuestionGroupCard } from './QuestionGroupCard';
import { UUID } from 'crypto';
import { ProductTypesMenu } from './ProductTypesMenu';

interface Props {
	productType: ProductType;
	formTemplate: FormTemplate;
	formDetails: FormDetails;
	hanleDetailsChange: (
		key: keyof FormDetails,
		value: FormDetails[keyof FormDetails]
	) => void;
	answersMap: Map<UUID, FormAnswerMap>;
	quantityPerDimension: QuantityPerDimensionForm;
	setQuantityPerDimension: Dispatch<SetStateAction<QuantityPerDimensionForm>>;
	isValidating: boolean;
	formOptions: FormOptions;
	hanldleOptionsChange: (
		key: keyof FormOptions,
		value: FormOptions[keyof FormOptions]
	) => void;
}

export const StepProduct: FC<Props> = ({
	productType,
	formTemplate,
	formDetails,
	hanleDetailsChange,
	answersMap,
	quantityPerDimension,
	setQuantityPerDimension,
	isValidating,
	formOptions,
	hanldleOptionsChange,
}) => {
	return (
		<Box style={{ flexGrow: 1 }}>
			<Flex
				justify="space-between"
				gap="sm"
				direction={{
					base: 'column',
					xs: 'row',
				}}
				mb={{ base: 'md', xs: 'sm' }}
			>
				<Title order={2} c="black" mb="sm">
					Formularz oferty - {productType.name}
				</Title>
				<ProductTypesMenu currentProductType={productType.id} />
			</Flex>
			{formTemplate.questionGroups.map((questionGroup, _, array) => (
				<QuestionGroupCard
					key={questionGroup.id}
					productType={productType}
					questionGroupsCount={array.length + 1}
					questionGroup={questionGroup}
					answersMap={answersMap}
					quantityPerDimension={quantityPerDimension}
					setQuantityPerDimension={setQuantityPerDimension}
					isValidating={isValidating}
					formOptions={formOptions}
					handleOptionsChange={hanldleOptionsChange}
				/>
			))}
			<OrderDetails
				productType={productType}
				formDetails={formDetails}
				hanleDetailsChange={hanleDetailsChange}
				questionGroupsCount={formTemplate.questionGroups.length + 1}
			/>
		</Box>
	);
};
